import Vue from 'vue';
import store from '@/store';
import Vconsole from 'vconsole';
var hostName = window.location.hostname;
var host = hostName.split('.')[0];
var isWhiteList = (hostName === '47.98.46.218') || (hostName === '47.97.160.180') || (hostName === 'web.chaolu.com.cn')
var hostArr = ['wx', 'wxs', 'app', 'apps', 'coach'];
const urlList={
    pro:{
        baseURL : 'https://wxs.chaolu.com.cn',
        baseURLApp : 'https://app.chaolu.com.cn',
        locationUrl : 'https://web.chaolu.com.cn',
        h5Url: 'https://h5.chaolu.com.cn'
    },
    dark:{
        baseURL : 'http://wxdark.chaolu.com.cn',
        baseURLApp : 'http://appdark.chaolu.com.cn',
        // baseURLApp : 'https://app.chaolu.com.cn',
        locationUrl : 'http://webdark.chaolu.com.cn',
        h5Url: 'https://h5-dark.chaolu.com.cn'
    },
    test: {
        baseURL: 'http://wxtest.chaolu.com.cn:80',
        baseURLApp: 'https://apptest.chaolu.com.cn',
        // baseURLApp: 'http://192.168.6.206:9013',
        locationUrl : window.location.origin,
        h5Url: 'https://h5-test.chaolu.com.cn'
    },
    beta: {
        baseURL: 'http://wxbeta.chaolu.com.cn:80',
        baseURLApp: 'https://appbeta.chaolu.com.cn',
        locationUrl: window.location.origin
    },
    dev: {
        baseURL: 'http://wxdev.chaolu.com.cn',
        baseURLApp: 'https://appdev.chaolu.com.cn',
        locationUrl: 'http://webdev.chaolu.com.cn'
    }
}
let urlJson={};
if (hostArr.includes(host) || isWhiteList) {
    urlJson=urlList.pro;
    Vue.prototype.isTestEnvironment=false;
}else{
    if(hostName === 'webdark.chaolu.com.cn'){
        urlJson=urlList.dark;
    } else if (hostName === 'webbeta.chaolu.com.cn') {
      urlJson=urlList.beta
    } else if (hostName === 'webdev.chaolu.com.cn') {
      urlJson=urlList.dev
    } else {
        urlJson = urlList.test;
    }
    new Vconsole();
    Vue.prototype.isTestEnvironment=true;
}
if(store.state.isdev){
    urlJson=urlList.test;
}
Vue.prototype.baseURL = urlJson.baseURL;
Vue.prototype.baseURLApp = urlJson.baseURLApp;
Vue.prototype.locationUrl = urlJson.locationUrl;
Vue.prototype.h5Url = urlJson.h5Url;
